export const FormatDate = (date) => {
  if (!date) return "";
  // Date-only strings like "2026-04-08" are parsed as UTC by the JS engine.
  // Appending T00:00:00 forces local-time parsing so the date never shifts
  // on machines whose UTC offset is behind UTC (e.g. Windows in US/PK timezones).
  const normalized =
    typeof date === "string" && /^\d{4}-\d{2}-\d{2}$/.test(date)
      ? date + "T00:00:00"
      : date;
  const options = { year: "numeric", month: "2-digit", day: "2-digit" };
  return new Date(normalized).toLocaleDateString("en-GB", options);
};
